<!-- file-data-table.component.html -->
<div class="flex min-w-0 flex-1 flex-col">
  <!-- Slot for things like breadcrumbs -->
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-file-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      <!-- Dynamic column rendering -->
      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>

            <!-- Switch based on column.key -->
            @switch (column.key) {
              @case ('filename') {
                <td
                  mat-cell
                  *matCellDef="let file"
                  class="max-w-[80px] truncate text-ellipsis whitespace-nowrap sm:max-w-[140px] md:max-w-[210px]"
                >
                  <div [matTooltip]="file.filename" class="truncate text-ellipsis whitespace-nowrap">
                    {{ file.filename }}
                  </div>
                </td>
              }
              @case ('mimeType') {
                <td mat-cell *matCellDef="let file">
                  @if (file.mimeType | isImage) {
                    <span
                      class="cursor-pointer"
                      (mouseenter)="showTooltip(file, $event, tooltip)"
                      (mouseleave)="hideTooltip()"
                    >
                      {{ file.mimeType }}
                    </span>
                  } @else {
                    <span>{{ file.mimeType }}</span>
                  }
                </td>
              }
              @case ('state.status') {
                <td mat-cell *matCellDef="let file">
                  <aura-state-status-chip [state]="file.state" />
                </td>
              }
              @case ('size') {
                <td mat-cell *matCellDef="let file">
                  {{ file.size | fileSizeDisplay }}
                </td>
              }
              @case ('purpose') {
                <td mat-cell *matCellDef="let file">
                  <aura-simple-chip [text]="file.purpose | filePurposeDisplay" />
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let file">
                  {{ file.createdAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('updatedAt') {
                <td mat-cell *matCellDef="let file">
                  {{ file.updatedAt | luxonDate: 'humanize' }}
                </td>
              }
              @case ('uploadedBy') {
                <td mat-cell *matCellDef="let file">
                  <button
                    [routerLink]="['/users', file.uploadedBy._id]"
                    mat-button
                    class="link flex flex-row items-center"
                  >
                    <aura-avatar
                      [label]="$safeNavigationMigration(file.uploadedBy.identity?.firstName)"
                      [srcImage]="$safeNavigationMigration(file.uploadedBy.identity.avatar?.url)"
                      [size]="'xs'"
                    />

                    <div class="ml-2">
                      {{ $safeNavigationMigration(file.uploadedBy.identity?.firstName) | titlecase }}
                      {{ $safeNavigationMigration(file.uploadedBy.identity?.lastName) | titlecase }}
                    </div>
                  </button>
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let file">
                  {{ file[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
<ng-template #tooltip let-file>
  <div class="max-h-[200px] max-w-[200px] rounded border bg-white p-1 shadow">
    <img
      [src]="file.thumbnail?.small?.url || file.url"
      class="h-full w-full object-contain"
      alt="file-thumbnail"
    />
  </div>
</ng-template>
